import { render, staticRenderFns } from "./PurchaseGalleryView.vue?vue&type=template&id=49560f7c&scoped=true&"
import script from "./PurchaseGalleryView.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGalleryView.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseGalleryView.vue?vue&type=style&index=0&id=49560f7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49560f7c",
  null
  
)

export default component.exports